<template>
<div>
  <el-scrollbar class="scrollbar-main">
    <Header />
    <vue-page-transition name="fade-in-left">
      <router-view class="page" />
    </vue-page-transition>
    <Footer />
  </el-scrollbar>
</div>
</template>

<script>
import Header from '@/components/Header/Header.vue';
import Footer from '@/components/Footer/Footer.vue';

export default {
  name: 'Layout',
  components: { Footer, Header },
};
</script>

<style scoped lang="scss">
.scrollbar-main,
.scrollbar {
  width: 100%;
  height: calc(100vh);
  // padding-right: 10px;
  box-sizing: border-box;
  overflow-x: hidden;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
  .el-scrollbar__view {
    height: 100%;
  }
}
.page {
  height: calc(100% - 200px);
}
</style>
